import { render } from "./App.vue?vue&type=template&id=ece40e84"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ece40e84&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__